import { useMemo } from 'react'

import { FUSION_CREATE_QUERY_PARAM, FUSION_CREATE_QUERY_VALUE } from '../Constants'

/**
 * Returns {@code true} when the current page was opened from the new Fusion UI's
 * "Create new report" entrypoint — signalled by the {@code ?fusionCreate=true} query param.
 *
 * The check is identical in every consumer (ConfigurationTabs, FooterActions); centralising
 * it keeps the literal query-param string in one place and avoids re-parsing
 * window.location.search at every component render.
 */
export const useIsFusionCreateMode = (): boolean =>
    useMemo(
        (): boolean =>
            new URLSearchParams(window.location.search).get(FUSION_CREATE_QUERY_PARAM) === FUSION_CREATE_QUERY_VALUE,
        []
    )
